import {authorized} from "./ApiClient";
import {send} from "./http";
import {LicenseViewModel, ProfileBindingModel, UserViewModel} from "./models";

// The signed-in user's own account.
export const ProfileApi = {
    get: () => authorized<UserViewModel>('GET', '/user-profile'),

    update: (model: ProfileBindingModel) => authorized<UserViewModel>('PUT', '/user-profile', model),

    changePassword: (password: string, newPassword: string) =>
        authorized<void>('PUT', '/user-profile/change-password', { password, newPassword }),

    // Emails a link (valid 10 minutes) to the new address; the change happens when it's opened.
    changeEmail: (emailAddress: string) => authorized<void>('PUT', '/user-profile/change-email', { emailAddress }),

    // From the emailed link: no session needed.
    verifyEmail: (token: string) => send<void>('PUT', '/user-profile/verify-email', { token }),

    licenses: () => authorized<LicenseViewModel[]>('GET', '/user-profile/license'),

    // Frees a seat on one of the user's licences. Doesn't refund the yearly activation count.
    freeSeat: (licenseId: string, activationId: string) =>
        authorized<void>('DELETE', `/user-profile/license/${encodeURIComponent(licenseId)}/activation/${encodeURIComponent(activationId)}`)
};
